import Vue from "vue";
import VueRouter from "vue-router";
import firebase from "firebase/app";

// import Layout from '../components/Layout.vue'
import Home from "../views/Home.vue";
import Rink from "../views/Rink.vue";
import Credits from "../views/Credits.vue";
import Feedback from "../views/Feedback.vue";
import AddRink from "../views/AddRink.vue";
import Stats from "../views/Stats.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/"
  },
  {
    path: "/",
    component: Home,
    children: [
      {
        path: "",
        name: "Home"
      },
      {
        path: "patinoires/:id",
        name: "Rink",
        component: Rink
      },
      {
        path: "credits",
        name: "Credits",
        component: Credits
      },
      {
        path: "commentaires",
        name: "Feedback",
        component: Feedback
      },
      {
        path: "ajouter",
        name: "AddRink",
        component: AddRink
      },
      {
        path: "historique",
        name: "Stats",
        component: Stats
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  if (!currentUser) {
    firebase.auth().signInAnonymously();
  }
  next();
});

export default router;
